'use client';

import React, { useEffect, useRef, useState } from 'react';

const ThreeColCardBar = ({ interval = 2000 }) => {
  const totalSteps = 3;
  const [currentStep, setCurrentStep] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const timer = setInterval(() => {
      setCurrentStep((prev) => {
        const next = prev + 1;

        return next >= totalSteps ? 0 : next;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [isVisible, interval, totalSteps]);

  return (
    <div
      ref={containerRef}
      className="hidden md:block relative w-full max-w-[84%] mx-auto mt-4 mb-4 px-6"
    >
      <div className="absolute top-[calc(50%-0.5px)] left-6 right-6 h-[1px] bg-violet-300 z-0" />

        <div className="flex items-center justify-between relative z-10">
          {[...Array(totalSteps)].map((_, index) => (
            <div
              key={index}
              className={`w-[11px] h-[11px] rounded-full transition-all duration-500 ${
                index <= currentStep ? 'bg-[#0D1D39]' : 'bg-violet-300'
              }`}
            />
          ))}
        </div>
      </div>
      );
      };

      export default ThreeColCardBar;
